import React, { useEffect, useState } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { useLocation } from "@reach/router";
import { pushtracking } from "../../../service/trackingService";
import "./css/personalized.css";

const Doiqua=()=> {

    const [meta, setMeta] = useState([]);
    const location = useLocation();
    useEffect(() => {
        try{
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Quy định tích và tiêu bixu", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                // console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[])
    const handleClick=(uri)=>{
        window.location.href = uri;
    }
    const handleBack=()=>{
        window.history.back();
    }
  return (
    <Layout>
        {/* <h1 className='d-none'>Mở ví - Đổi quà</h1> */}
        <div className="fixed">
            <div className="header1 filter">
                <div className="row mgx-0 pdy-10 pdx-0">
                    <div className="col-2 in-f">
                        <a onClick={handleBack}>
                            <img src="/../images/voucher/ic_back.svg" alt="icon"/>
                        </a>
                    </div>
                    <div className="col-8 text-center">
                        <strong className="text_header  color_black">QUY ĐỊNH TÍCH & TIÊU BIXU</strong>
                    </div>
                    <div className="col-2"></div>
                </div>
            </div>  
        </div>
        <div style={{ height: 40 }}></div>
        <div className="pdx-20 regulation-bixu bg-white mgt-10">
            <div>
                <div className="regulation-title">
                    <span>1. Quy định Tích Bixu</span>
                </div>
                <div className="regulation-text mgt-10">
                    <ul>
                        <li>Bixu sẽ được cộng vào Ví của Ba Mẹ ngay khi hoàn tất giao dịch mua sắm, săn xu,  trúng thưởng hoặc làm nhiệm vụ thành công.</li>
                        <li>Bixu vừa nhận sẽ được hệ thống kích hoạt sau 24h. Ba Mẹ có thể tiêu số Bixu vừa tích được vào ngày D+1 kể từ ngày tích.</li>
                        <li>Quy đổi 1 Bixu = 1 đồng.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div className="regulation-title" >
                    <span>2. Quy định hoàn trả Bixu</span>
                </div>
                <div className="regulation-text mgt-10">
                    <ul>
                        <li>Nếu Ba Mẹ hoàn/hủy đơn hàng, Bixu sẽ được hoàn lại vào Ví của Ba Mẹ ngay khi hoàn tất giao dịch hoàn/huỷ.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div className="regulation-title">
                    <span>3. Hiệu lực của Bixu</span>
                </div>
                <div className="regulation-text mgt-10">
                    <ul>
                        <li>Bixu có hiệu lực trong vòng 90 ngày kể từ ngày mua sắm gần nhất. Ba Mẹ cần đảm bảo có giao dịch mua sắm phát sinh trong vòng 90 ngày kể từ ngày tích xu để kích hoạt Bixu.</li>
                        <li>Bixu hết hiệu lực sẽ bị trừ khỏi Ví.</li>
                        <li>Bixu có thể tiêu trong thời gian còn hiệu lực và trên toàn hệ thống Bibo Mart (bao gồm các siêu thị offline và mua hàng trực tuyến qua website và App Bibo Mart).</li>
                        <li>Bixu không áp dụng tiêu khi mua hàng trên các sàn TMĐT và các kênh livestream trên các nền tảng xã hội như Tiktok, Shopee... của Bibo Mart.</li>
                    </ul>
                </div>
            </div>
            <div className="border-bottom">
                <div className="regulation-title">
                    <span>4. Quy định Tiêu Bixu</span>
                </div>
                <div className="regulation-text mgt-10">
                    <ul>
                        <li>Bixu có thể dùng để đổi quà ở trang Đổi quà</li>
                        <li>Bixu không có giá trị quy đổi thành tiền mặt và cho/tặng giữa các tài khoản.</li>
                    </ul>
                </div>
            </div>
            <div className="row mgx-0 regulation-footer border-bottom pdy-10">
                <div className="col-12 regulation-footer-text in-f">Mọi thắc mắc, vui lòng liên hệ:</div>
                <div className="col-12 regulation-footer-text in-f"><span className="text-red">P. Chăm sóc Khách hàng</span></div>
                <div className="col-12 regulation-footer-text in-f"><span className="text-red">Công ty Cổ phần Bibo Mart TM</span></div>
                <div className="col-12 regulation-footer-text in-f">Hotline: 1800 6886 (Miễn phí)</div>
                <div className="col-12 regulation-footer-text in-f">Email: cskh@bibomart.com.vn</div>
            </div>
            <div className="row mgx-0 pdy-10 pdx-12">
                <div className="col-12 regulation-footer-text in-f mgb-10">
                    <span className="text-red">Công ty Cổ phần Bibo Mart TM</span>
                </div>
                <ul className="pdx-10">
                    <li className="regulation-footer-text">Trụ sở: 120 Trần Duy Hưng, Phường Yên Hòa, Thành phố Hà Nội.</li>
                    <li className="regulation-footer-text">Văn phòng Miền Bắc: Tầng 10, Tòa Handico, Đường Phạm Hùng, Phường Từ Liêm, Thành phố Hà Nội. Số điện thoại: (024) 7309 1168</li>
                    <li className="regulation-footer-text">Văn phòng Miền Nam: Tầng 3, số 2A Nguyễn Oanh, Phường Hạnh Thông, TP.Hồ Chí Minh.</li>
                </ul>
            </div>
            <div className="regulation-title">
                <div className="text-align-center">
                    <span>Xem thêm <a href="bibomart://policy-warrantyPolicy">Quy định sử dụng Web & App</a></span>
                </div>
            </div>
            <div className="regulation-title">
                <div className="text-align-center">
                    <span>Xem thêm <a href="bibomart://policy-warrantyPolicy">Chính sách Bảo mật</a></span>
                </div>
            </div>
            <div className="regulation-title">
                <div className="text-align-center">
                    <span>Xem thêm <a href="bibomart://policy-warrantyPolicy">Chính sách Bảo hành</a></span>
                </div>
            </div>
        </div>
    </Layout>
  )
}
export default Doiqua;